// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".camera-status[data-v-6b95869e]{height:7px;margin-left:-2px;position:relative;width:7px}.camera-status--online[data-v-6b95869e]{background:#4caf50}.camera-status__icon[data-v-6b95869e]{font-size:12px!important;position:absolute!important;top:-3px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
